import { useEffect, useRef } from "react";
import { MessageSquarePlus } from "lucide-react";
import { MessageBubble } from "./MessageBubble";
import { ProgressSteps } from "./ProgressSteps";

export function ChatWindow({ messages, isSending, onSendMessage, emptyState, steps, startedAt, plan, onCancel }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isSending, steps, plan]);

  const isEmpty = (!messages || messages.length === 0) && !isSending;

  if (isEmpty && emptyState) {
    return (
      <div data-testid="chat-window" className="flex-1 overflow-y-auto flex items-center justify-center px-4 py-6">
        <div data-testid="chat-empty-state">{emptyState}</div>
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div data-testid="chat-window" className="flex-1 flex items-center justify-center px-4">
        <div data-testid="chat-empty-state" className="text-center max-w-sm space-y-3">
          <MessageSquarePlus className="h-8 w-8 mx-auto text-muted-foreground/50" />
          <p className="text-sm text-muted-foreground">
            Conversación nueva. Escribe tu primer mensaje para este proyecto.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="chat-window" className="flex-1 overflow-y-auto px-4 py-6">
      <div className="max-w-3xl mx-auto space-y-7">
        {messages?.map((m) => (
          <MessageBubble key={m.id} message={m} onSendMessage={onSendMessage} />
        ))}
        {isSending && (
          <div data-testid="chat-loading-indicator">
            <ProgressSteps steps={steps} startedAt={startedAt} plan={plan} onCancel={onCancel} />
          </div>
        )}
        <div ref={bottomRef} />
      </div>
    </div>
  );
}
